
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/report-print",
      function () {
        return require("private-next-pages/report-print.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/report-print"])
      });
    }
  